import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="check_circle_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M128 512a384 384 0 1 1 768 0 384 384 0 0 1-768 0zM512 42.667C252.8 42.667 42.667 252.8 42.667 512S252.8 981.333 512 981.333 981.333 771.2 981.333 512 771.2 42.667 512 42.667zm222.55 392.448a42.667 42.667 0 1 0-61.1-59.563L453.29 601.344l-103.85-98.901a42.667 42.667 0 1 0-58.88 61.781l134.101 127.701c17.067 16.299 44.118 15.787 60.587-1.109l249.301-255.701z"
    />
  </svg>
);
export default SvgCheckCircleIcon;
